import Backbone from 'backbone';
import Page from './page.js';
import moment from 'moment';

const PageCollection = Backbone.Collection.extend({
  
  comparator(model){
    return -(parseInt(model.get('id'), 10));
  },
  
  model: Page,
  
  initialize(models, options) {
    this._urlParams = null;
    if (options && typeof options.params !== 'undefined') {
      this._urlParams = options.params;
    }
  },

  url() {
    var urlString = '/api/pages';
    if (this._urlParams) {
      urlString += '?' + $.param(this._urlParams);
    }
    return urlString;
  }

}, {
  // classmethods
  
  /* 
    sort values for Backbone.Obscura are defined here. Since functions are compared
    as values to one anpther to detemrine which sort is being used, there
    needs to be one canonical place where they are defined and from which they are used.
    This is that place
  */

  getAlphabeticSortValue(page) {
    return page.get('unpublishedName').toLowerCase();
  },

  getLastPublishedDateValue(page) {
    if (page.get('last_published_at')) {
      return moment(page.get('last_published_at'));
    }
    return null;
  },

  getCreatedAtValue(page) {
    if (page.get('createdAtTs')) {
      return moment(page.get('createdAtTs'));
    }
    return null;
  }
});

export default PageCollection;
